import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import {Cartesian2, Cartesian3, Color, DistanceDisplayCondition} from "cesium";
/**
 *传感器设备图层
 */
class DeviceLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.DEVICE;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(Number(item.longitude),Number(item.latitude), CONSTANTS.ALTITUDE),
                    name: item.tagId,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("@/assets/img/map/device.png"),
                        show : true,
                        width : 48,
                        height : 48,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    },
                    label:{
                        text : item.tagId,
                        color :Color.fromCssColorString('#fff'),
                        //backgroundColor:Color.fromCssColorString('#fff'),
                        zIndex:1000000,
                        font:'normal 32px MicroSoft YaHei',
                        showBackground : true,
                        scale : 0.4,
                        distanceDisplayCondition : new DistanceDisplayCondition(0, 500),
                        pixelOffset:new Cartesian2(-10, 30),
                        eyeOffset:new Cartesian3(0,0,-100),
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
}
export default DeviceLayer;
